import { Typography } from '@mui/material';
import { FormSection } from 'components/form';
import { DEVICE_GAUGE_PICTURE_ID } from 'types';
import { PictureCapture } from '../../PictureCapture/PictureCapture';
import { useFormState } from 'hooks/useFormState';
import { useEffect } from 'react';

export function CreateDeviceModalGaugePictureSection() {
    const formSectionTitle = 'Gauge Picture';

    // Manage the submit button state
    const { setIsFormSubmitDisabled, currentFormSectionIndex, formSections } =
        useFormState();
    useEffect(() => {
        if (
            currentFormSectionIndex === formSections.indexOf(formSectionTitle)
        ) {
            setIsFormSubmitDisabled(false);
        }
    }, [setIsFormSubmitDisabled, currentFormSectionIndex, formSections]);

    return (
        <FormSection title={formSectionTitle}>
            <Typography variant="h6">
                Please take a photo of the current dial reading
            </Typography>
            <PictureCapture
                field="installAttempts.gaugePicture"
                pictureTypeId={DEVICE_GAUGE_PICTURE_ID}
            />
        </FormSection>
    );
}
